const seach = {
	// banner: [{
	// 	tips:'联系我们',
	// 	title:'公司简介',
	// 	content:'',
	// 	img: require('@/assets/img/index/GPI_2x.png'),
	// 	url: require('@/assets/img/index/banner01.png')
	// }],
	PCR:{
		down_CN:'中文版PCR下载',
		down_EN:'英文版PCR下载',
		seach_btn:'搜索',
		seach:'已公告/发布的PCR',
		num:'个PCR文件',
		rest:'重置',
		form:{			
			PCR:'产品种类',
			seach:'关键字',
			year:'年份',
			keywords:'请输入关键字',
			tips:"请选择产品种类",
			year_tips:'请选择年份'
		},
		label:{
			name:"名称：",
			briefIntroduction:"编制人：",
			time:'有效期：',
			registrationNo:'注册号：',
			describes:'PCR简介：',
			sycp:'适用产品：',
			pczl:'产品种类分类：'
		}	
	},
	EPD:{
		down_EPD:'EPD报告下载',
		down_LCA:'LCA报告下载',
		down_CFP:'CFP报告下载',
		down_CN:'中文版EPD下载',
		down_EN:'英文版EPD下载',
		seach_btn:'搜索',
		seach:'已公告/发布的EPD/CFP',
		num:'个EPD/CFP文件',
		rest:'重置',
		form:{
			companyName:'公司名称',
			PCR:'选择产品种类',
			type:'选择类别',
			seach:'关键字',
			keywords:'请输入关键字',
			tips:"请选择产品种类",
			c_tips:"请输入公司名称",
			type_tips:"请选择类别"
		},
		label:{
			sampleName:"产品名称：",
			briefIntroduction:"编制人：",
			expirationDate:'有效期至：',
			serialNo:'注册号：',
			productInfo:'产品简介：',
			sycp:'适用产品：',
			productCategoryName:'产品种类分类：',
			
			companyName:'请输入企业名称',
			// sampleName:"请输入产品名称",
			address: '产品生产地址',
			// productInfo:'请输入产品描述',
			// productCategory:'请选择产品种类',
		},
	}
	
}

export default seach